"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountListHeader = exports.AccountDrawerToggle = void 0;
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const classnames_1 = __importDefault(require("classnames"));
const styles_1 = require("@mui/material/styles");
const AddRounded_1 = __importDefault(require("@mui/icons-material/AddRounded"));
const ChevronRightRounded_1 = __importDefault(require("@mui/icons-material/ChevronRightRounded"));
const ChevronLeftRounded_1 = __importDefault(require("@mui/icons-material/ChevronLeftRounded"));
const MoreVert_1 = __importDefault(require("@mui/icons-material/MoreVert"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuList_1 = __importDefault(require("@mui/material/MenuList"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const ListItem_1 = __importDefault(require("@mui/material/ListItem"));
const ListItemIcon_1 = __importDefault(require("@mui/material/ListItemIcon"));
const Check_1 = __importDefault(require("@mui/icons-material/Check"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Portal_1 = __importDefault(require("@mui/material/Portal"));
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const actions_1 = require("companion-app-components/flux/preferences/actions");
const selectors_1 = require("companion-app-components/flux/preferences/selectors");
const types_1 = require("companion-app-components/flux/preferences/types");
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const BalanceSelectMenu_1 = __importDefault(require("components/BalanceSelectMenu"));
const RefreshButton_1 = __importDefault(require("containers/App/Header/RefreshButton"));
const QButton_1 = __importDefault(require("components/QButton"));
const AccountDrawerToggle = (props) => {
    const { classes, handleDrawerToggle, open, anchorEl } = props;
    const [isQTipOpen, setIsQTipOpen] = React.useState(true);
    const DrawerControlIcon = open ? ChevronLeftRounded_1.default : ChevronRightRounded_1.default;
    // Once the value of open changes, we know it is safe to show QTips again without the 'render forever' ToolTip bug!
    React.useEffect(() => {
        setIsQTipOpen(true);
    }, [open]);
    // This guarantees there is no race condition and setQTipOpen is always set to false first!
    const toggleQTip = (e, callback) => {
        setIsQTipOpen(false);
        callback(e);
    };
    const renderQIconButton = () => (<QIconButton_1.default size="small-no-padding" aria-label="Close the account bar" onClick={(e) => {
            toggleQTip(e, handleDrawerToggle);
        }} id="account-drawer-toggle" className={classes.drawerQIconButton}>
      <DrawerControlIcon className={classes.drawerIcons}/>
    </QIconButton_1.default>);
    return (<Portal_1.default container={anchorEl}>
      <div className={(0, classnames_1.default)(classes.drawerOpenControl, open ? 'open' : '')}>
        {/* This was to fix a bug where the QTip remained onscreen forever
        if it was rendered during the AccountDrawer opening/closing */}
        {isQTipOpen ? (<QTip_1.default title={`${!open ? 'Open' : 'Close'} the account bar`} placement="right" wrapId="account-drawer">
            {renderQIconButton()}
          </QTip_1.default>) : renderQIconButton()}

      </div>
    </Portal_1.default>);
};
exports.AccountDrawerToggle = AccountDrawerToggle;
const balanceMenuItems = [{
        primary: 'Balance with pending',
        secondary: 'Your bank balance minus any pending transactions. This balance is used to project your cash flow.',
        showBalance: types_1.ShowBalance.INCLUDE_PENDING,
    }, {
        primary: 'Bank Balance',
        secondary: 'The balance we received from your bank. It typically does not include pending transactions.',
        showBalance: types_1.ShowBalance.BANK_REPORTED,
    }];
const AccountListHeader = ({ classes, addFiEnabled, handleAddInstitutionLogin, }) => {
    const theme = (0, styles_1.useTheme)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [balanceMenuAnchorEl, setBalanceMenuAnchorEl] = React.useState(null);
    const showBalance = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getSharedPreferencesByPath)(state, { group: 'dataset', path: ['shared', 'showBalance'] }))
        || types_1.ShowBalance.INCLUDE_PENDING;
    const balanceToggle = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlag(state, 'balanceToggle'));
    const label = theme.components.accountDrawer.addFiLabel;
    const size = theme.components.accountDrawer.actionButtonSize;
    return (<>
      <Typography_1.default variant="h5" className={classes.drawerListTitle}>
        Accounts
      </Typography_1.default>
      <RefreshButton_1.default isInAccountBar 
    // @ts-expect-error TS(2322) - FIXME: Property 'id' does not exist on type 'IntrinsicAttributes & RefreshButtonProps'
    id="sync-arrow" classes={{ buttonRoot: classes.drawerHeaderIcons }}/>
      {addFiEnabled && (<QTip_1.default title="Add your account" placement="right">
          <QButton_1.default id="addFiButton" aria-label="Add Institution Login" onClick={handleAddInstitutionLogin()} style={{
                minWidth: 0,
                backgroundColor: 'transparent',
                height: !label && size,
                width: !label && size,
                marginRight: label && -16,
            }} variant={label ? 'text' : 'containedIcon'}>
            <AddRounded_1.default className={!label ? classes.drawerHeaderIcons : ''}/>
            {label && <Box_1.default component="span" mt={0.25}/>}
          </QButton_1.default>
        </QTip_1.default>)}

      {balanceToggle && (<div role="none" onClick={(event) => event.stopPropagation()}>
          <IconButton_1.default id="balance-options" aria-label="balance options" className={classes.buttonShift} onClick={(event) => {
                setBalanceMenuAnchorEl(event.currentTarget);
                event.stopPropagation();
            }} size="large">
            <MoreVert_1.default />
          </IconButton_1.default>

          <Menu_1.default id="balance-menu" anchorEl={balanceMenuAnchorEl} transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }} keepMounted open={Boolean(balanceMenuAnchorEl)} onClose={() => setBalanceMenuAnchorEl(null)} PaperProps={{
                style: { maxWidth: '38ch' },
            }}>
            <MenuList_1.default className={classes.borderCols}>
              {balanceMenuItems.map((item) => (<ListItem_1.default key={item.primary} id={item.primary} button selected={item.showBalance === showBalance} alignItems="flex-start" onClick={(event) => {
                    event.stopPropagation();
                    dispatch((0, actions_1.setPreference)({
                        section: 'shared',
                        group: 'dataset',
                        preference: {
                            shared: {
                                showBalance: item.showBalance,
                            },
                        },
                    }));
                    setBalanceMenuAnchorEl(null);
                }}>
                  <ListItemIcon_1.default>
                    {item.showBalance === showBalance && <Check_1.default color="primary"/>}
                  </ListItemIcon_1.default>
                  <ListItemText_1.default primary={item.primary} secondary={item.secondary}/>
                </ListItem_1.default>))}
            </MenuList_1.default>
          </Menu_1.default>
        </div>)}
      <BalanceSelectMenu_1.default classes={{ balanceMenu: classes.balanceMenu, iconColor: classes.drawerHeaderIcons }} menuIconButtonSize="small"/>
    </>);
};
exports.AccountListHeader = AccountListHeader;
